/* AUTO-GENERATED FILE — DO NOT EDIT.
 *
 * Client-file model types shared by both frontends, extracted from a generated api-client (SONeuWebApp's when present, otherwise
 * SONeuExternalApp's) and validated against external-api.json (every model here is part of the
 * portal-exposed subset). Type declarations only — no runtime serialisers — so @shared depends
 * on no app's client.
 *
 * Regenerate: `npm run generateApiClient` in either app (both invoke the emitter)
 * Emitted by:  Frontend/api-codegen/emit-shared-models.mjs
 * Consumed by: @shared/src/client-file/api/ClientFileApi.ts (the ClientFileApi seam)
 */

/**
 * 
 * @export
 * @interface BankruptcyCapabilityResponse
 */
export interface BankruptcyCapabilityResponse {
    /**
     * 
     * @type {number}
     * @memberof BankruptcyCapabilityResponse
     */
    monthlyIncome: number;
    /**
     * 
     * @type {number}
     * @memberof BankruptcyCapabilityResponse
     */
    monthlyExpenses: number;
    /**
     * 
     * @type {number}
     * @memberof BankruptcyCapabilityResponse
     */
    seizableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof BankruptcyCapabilityResponse
     */
    maintenanceObligationCount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyCapabilityResponse
     */
    isAssetInventoryComplete: boolean;
}

/**
 * 
 * @export
 * @interface BankruptcyChecklistResponse
 */
export interface BankruptcyChecklistResponse {
    /**
     * 
     * @type {string}
     * @memberof BankruptcyChecklistResponse
     */
    clientId: string;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasRentArrears: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasUtilityArrears: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasOpenPenalties: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasInstallmentAgreement: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    canMeetInstallmentAgreement: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasChildrenWithMaintenance: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    paysFullMaintenance: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isMaintenanceGarnished: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    wasPreviouslySelfEmployed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isCurrentlySelfEmployed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasBusinessLicense: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    exercisesTradeAsBusiness: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isBusinessLicenseDormant: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasMaintenanceArrears: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasCriminalDebts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasCreditDebts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    creditWithinLastFiveYears: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BankruptcyChecklistResponse
     */
    creditRemark: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasMailOrderDebts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    mailOrderWithinLastThreeYears: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BankruptcyChecklistResponse
     */
    mailOrderRemark: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasNeverPaidDebts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasOwnCheckingAccount: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isCheckingAccountOverdrawn: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    hasRegisteredMobilePhone: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isElectricityInOwnName: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isApartmentDistrictHeated: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankruptcyChecklistResponse
     */
    isDistrictHeatingInOwnName: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof BankruptcyChecklistResponse
     */
    lastChangedAtUtc: Date | null;
    /**
     * 
     * @type {BankruptcyCapabilityResponse}
     * @memberof BankruptcyChecklistResponse
     */
    bankruptcyCapability: BankruptcyCapabilityResponse;
}

/**
 * 
 * @export
 * @interface SaveBankruptcyConsequencesRequest
 */
export interface SaveBankruptcyConsequencesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveBankruptcyConsequencesRequest
     */
    hasOwnCheckingAccount?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBankruptcyConsequencesRequest
     */
    isCheckingAccountOverdrawn?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBankruptcyConsequencesRequest
     */
    hasRegisteredMobilePhone?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBankruptcyConsequencesRequest
     */
    isElectricityInOwnName?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBankruptcyConsequencesRequest
     */
    isApartmentDistrictHeated?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveBankruptcyConsequencesRequest
     */
    isDistrictHeatingInOwnName?: boolean | null;
}

/**
 * 
 * @export
 * @interface SaveDangerousDebtsRequest
 */
export interface SaveDangerousDebtsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    hasRentArrears?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    hasUtilityArrears?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    hasOpenPenalties?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    hasInstallmentAgreement?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    canMeetInstallmentAgreement?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    hasChildrenWithMaintenance?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    paysFullMaintenance?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    isMaintenanceGarnished?: boolean | null;
}

/**
 * 
 * @export
 * @interface SaveSpecialDebtsRequest
 */
export interface SaveSpecialDebtsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    wasPreviouslySelfEmployed?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    isCurrentlySelfEmployed?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    hasBusinessLicense?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    exercisesTradeAsBusiness?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    isBusinessLicenseDormant?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    hasMaintenanceArrears?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    hasCriminalDebts?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    hasCreditDebts?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    creditWithinLastFiveYears?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSpecialDebtsRequest
     */
    creditRemark?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    hasMailOrderDebts?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    mailOrderWithinLastThreeYears?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSpecialDebtsRequest
     */
    mailOrderRemark?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    hasNeverPaidDebts?: boolean | null;
}

/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    country: string | null;
}

/**
 * 
 * @export
 * @interface AssetAnswersDto
 */
export interface AssetAnswersDto {
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasDomesticRealEstate: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    domesticRealEstateDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasForeignRealEstate: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    foreignRealEstateDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasBuildingSavingsContracts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasSavingsAccounts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasLifeInsurances: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasPensionInsurances: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasSecuritiesDepots: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasSafeDeposit: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    safeDepositDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasOtherCashAssets: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    isSavedForProceeding: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetAnswersDto
     */
    savedForProceedingAmount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetAnswersDto
     */
    savedForProceedingDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    otherCashAssetsDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasValuables: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    valuablesDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasFurnishings: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    furnishingsDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasAppliances: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    appliancesDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasEquipment: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    equipmentDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasVehicles: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    vehiclesDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasBuildingsOnForeignLand: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    buildingsOnForeignLandDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    hasOtherItems: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    otherItemsDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAnswersDto
     */
    ownsAllItems: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAnswersDto
     */
    itemsOwnedByOthersDetails: string | null;
}

/**
 * 
 * @export
 */
export const AssetDocumentArea = {
    DomesticRealEstate: 'DomesticRealEstate',
    ForeignRealEstate: 'ForeignRealEstate',
    BuildingSavingsContracts: 'BuildingSavingsContracts',
    SavingsAccounts: 'SavingsAccounts',
    LifeInsurances: 'LifeInsurances',
    PensionInsurances: 'PensionInsurances',
    SecuritiesDepots: 'SecuritiesDepots',
    CashAndBankAssets: 'CashAndBankAssets',
    Vehicles: 'Vehicles',
    BuildingsOnForeignLand: 'BuildingsOnForeignLand',
    TenancyRights: 'TenancyRights',
    CompanyShares: 'CompanyShares',
    CooperativeMemberships: 'CooperativeMemberships',
    OtherPropertyRights: 'OtherPropertyRights',
    Donations: 'Donations'
} as const;
export type AssetDocumentArea = typeof AssetDocumentArea[keyof typeof AssetDocumentArea];

/**
 * 
 * @export
 */
export const AssetEncumbrance = {
    Yes: 'Yes',
    No: 'No',
    Unknown: 'Unknown'
} as const;
export type AssetEncumbrance = typeof AssetEncumbrance[keyof typeof AssetEncumbrance];

/**
 * 
 * @export
 */
export const AssetFinancialHoldingKind = {
    BuildingSavingsContract: 'BuildingSavingsContract',
    SavingsAccount: 'SavingsAccount',
    LifeInsurance: 'LifeInsurance',
    PensionInsurance: 'PensionInsurance',
    SecuritiesDepot: 'SecuritiesDepot'
} as const;
export type AssetFinancialHoldingKind = typeof AssetFinancialHoldingKind[keyof typeof AssetFinancialHoldingKind];

/**
 * 
 * @export
 * @interface AssetFinancialHoldingRequest
 */
export interface AssetFinancialHoldingRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingRequest
     */
    id: string | null;
    /**
     * 
     * @type {AssetFinancialHoldingKind}
     * @memberof AssetFinancialHoldingRequest
     */
    kind: AssetFinancialHoldingKind;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingRequest
     */
    institutionName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingRequest
     */
    accountNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingRequest
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingRequest
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingRequest
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingRequest
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingRequest
     */
    country: string | null;
    /**
     * 
     * @type {AssetEncumbrance}
     * @memberof AssetFinancialHoldingRequest
     */
    encumbrance: AssetEncumbrance | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingRequest
     */
    encumberedClaimId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetFinancialHoldingRequest
     */
    usedForProceedingCosts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetFinancialHoldingRequest
     */
    isValueKnown: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetFinancialHoldingRequest
     */
    value: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetFinancialHoldingRequest
     */
    valueDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingRequest
     */
    remarks: string | null;
}

/**
 * 
 * @export
 * @interface AssetFinancialHoldingResponse
 */
export interface AssetFinancialHoldingResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    id: string;
    /**
     * 
     * @type {AssetFinancialHoldingKind}
     * @memberof AssetFinancialHoldingResponse
     */
    kind: AssetFinancialHoldingKind;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    institutionName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    accountNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    country: string | null;
    /**
     * 
     * @type {AssetEncumbrance}
     * @memberof AssetFinancialHoldingResponse
     */
    encumbrance: AssetEncumbrance | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    encumberedClaimId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetFinancialHoldingResponse
     */
    usedForProceedingCosts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetFinancialHoldingResponse
     */
    isValueKnown: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetFinancialHoldingResponse
     */
    value: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetFinancialHoldingResponse
     */
    valueDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    remarks: string | null;
}

/**
 * 
 * @export
 * @interface AssetsTabResponse
 */
export interface AssetsTabResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetsTabResponse
     */
    clientId: string;
    /**
     * 
     * @type {AssetAnswersDto}
     * @memberof AssetsTabResponse
     */
    answers: AssetAnswersDto;
    /**
     * 
     * @type {Array<AssetFinancialHoldingResponse>}
     * @memberof AssetsTabResponse
     */
    financialHoldings: Array<AssetFinancialHoldingResponse>;
}

/**
 * 
 * @export
 * @interface DonationAnswersDto
 */
export interface DonationAnswersDto {
    /**
     * 
     * @type {boolean}
     * @memberof DonationAnswersDto
     */
    hasGratuitousDispositions: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DonationAnswersDto
     */
    gratuitousDispositionsDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DonationAnswersDto
     */
    hasOtherDispositions: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DonationAnswersDto
     */
    otherDispositionsDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DonationAnswersDto
     */
    hasAssetSettlement: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DonationAnswersDto
     */
    assetSettlementDetails: string | null;
}

/**
 * 
 * @export
 * @interface DonationsTabResponse
 */
export interface DonationsTabResponse {
    /**
     * 
     * @type {string}
     * @memberof DonationsTabResponse
     */
    clientId: string;
    /**
     * 
     * @type {DonationAnswersDto}
     * @memberof DonationsTabResponse
     */
    answers: DonationAnswersDto;
}

/**
 * 
 * @export
 */
export const AssetPropertyRightKind = {
    Tenancy: 'Tenancy',
    CompanyShare: 'CompanyShare',
    CooperativeMembership: 'CooperativeMembership',
    Other: 'Other'
} as const;
export type AssetPropertyRightKind = typeof AssetPropertyRightKind[keyof typeof AssetPropertyRightKind];

/**
 * 
 * @export
 * @interface AssetPropertyRightRequest
 */
export interface AssetPropertyRightRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightRequest
     */
    id: string | null;
    /**
     * 
     * @type {AssetPropertyRightKind}
     * @memberof AssetPropertyRightRequest
     */
    kind: AssetPropertyRightKind;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightRequest
     */
    landlord: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPropertyRightRequest
     */
    isCurrentHome: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightRequest
     */
    propertyDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPropertyRightRequest
     */
    expectsProceeds: boolean | null;
    /**
     * 
     * @type {AssetEncumbrance}
     * @memberof AssetPropertyRightRequest
     */
    proceedsEncumbrance: AssetEncumbrance | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightRequest
     */
    encumberedClaimId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPropertyRightRequest
     */
    isProceedsAmountKnown: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetPropertyRightRequest
     */
    proceedsAmount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetPropertyRightRequest
     */
    proceedsDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightRequest
     */
    remarks: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightRequest
     */
    details: string | null;
}

/**
 * 
 * @export
 * @interface AssetPropertyRightResponse
 */
export interface AssetPropertyRightResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightResponse
     */
    id: string;
    /**
     * 
     * @type {AssetPropertyRightKind}
     * @memberof AssetPropertyRightResponse
     */
    kind: AssetPropertyRightKind;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightResponse
     */
    landlord: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPropertyRightResponse
     */
    isCurrentHome: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightResponse
     */
    propertyDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPropertyRightResponse
     */
    expectsProceeds: boolean | null;
    /**
     * 
     * @type {AssetEncumbrance}
     * @memberof AssetPropertyRightResponse
     */
    proceedsEncumbrance: AssetEncumbrance | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightResponse
     */
    encumberedClaimId: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightResponse
     */
    encumberedCreditorName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPropertyRightResponse
     */
    isProceedsAmountKnown: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetPropertyRightResponse
     */
    proceedsAmount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetPropertyRightResponse
     */
    proceedsDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightResponse
     */
    remarks: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPropertyRightResponse
     */
    details: string | null;
}

/**
 * 
 * @export
 * @interface PropertyRightAnswersDto
 */
export interface PropertyRightAnswersDto {
    /**
     * 
     * @type {boolean}
     * @memberof PropertyRightAnswersDto
     */
    hasTenancyRights: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyRightAnswersDto
     */
    tenantOrOwnerOfHomeAddress: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyRightAnswersDto
     */
    hasCompanyShares: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyRightAnswersDto
     */
    hasCooperativeMemberships: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyRightAnswersDto
     */
    hasOtherPropertyRights: boolean | null;
}

/**
 * 
 * @export
 * @interface PropertyRightsTabResponse
 */
export interface PropertyRightsTabResponse {
    /**
     * 
     * @type {string}
     * @memberof PropertyRightsTabResponse
     */
    clientId: string;
    /**
     * 
     * @type {PropertyRightAnswersDto}
     * @memberof PropertyRightsTabResponse
     */
    answers: PropertyRightAnswersDto;
    /**
     * 
     * @type {AddressDto}
     * @memberof PropertyRightsTabResponse
     */
    homeAddress: AddressDto;
    /**
     * 
     * @type {Array<AssetPropertyRightResponse>}
     * @memberof PropertyRightsTabResponse
     */
    propertyRights: Array<AssetPropertyRightResponse>;
}

/**
 * 
 * @export
 * @interface AssetAccountRequest
 */
export interface AssetAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetAccountRequest
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAccountRequest
     */
    bankName: string | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof AssetAccountRequest
     */
    address: AddressDto | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAccountRequest
     */
    iban: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAccountRequest
     */
    incomings: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAccountRequest
     */
    isOverdrawn: boolean | null;
}

/**
 * 
 * @export
 * @interface AssetAccountResponse
 */
export interface AssetAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetAccountResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetAccountResponse
     */
    bankName: string | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof AssetAccountResponse
     */
    address: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof AssetAccountResponse
     */
    iban: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAccountResponse
     */
    incomings: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAccountResponse
     */
    isOverdrawn: boolean | null;
}

/**
 * 
 * @export
 * @interface AssetDependantRequest
 */
export interface AssetDependantRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetDependantRequest
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDependantRequest
     */
    firstName: string | null;
    /**
     * 
     * @type {RelationshipType}
     * @memberof AssetDependantRequest
     */
    relationship: RelationshipType | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetDependantRequest
     */
    birthDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantRequest
     */
    livesInHousehold: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantRequest
     */
    isJointlyLiable: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantRequest
     */
    isEntitledToMaintenance: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantRequest
     */
    hasToPayAlimony: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetDependantRequest
     */
    monthlyAlimonyAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantRequest
     */
    paidFullLastMonth: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantRequest
     */
    fullyGarnishedLastMonth: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDependantRequest
     */
    note: string | null;
}

/**
 * 
 * @export
 * @interface AssetDependantResponse
 */
export interface AssetDependantResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetDependantResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDependantResponse
     */
    firstName: string | null;
    /**
     * 
     * @type {RelationshipType}
     * @memberof AssetDependantResponse
     */
    relationship: RelationshipType | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetDependantResponse
     */
    birthDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantResponse
     */
    livesInHousehold: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantResponse
     */
    isJointlyLiable: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantResponse
     */
    isEntitledToMaintenance: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantResponse
     */
    hasToPayAlimony: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetDependantResponse
     */
    monthlyAlimonyAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantResponse
     */
    paidFullLastMonth: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDependantResponse
     */
    fullyGarnishedLastMonth: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDependantResponse
     */
    note: string | null;
}

/**
 * 
 * @export
 * @interface AssetDependantsResponse
 */
export interface AssetDependantsResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetDependantsResponse
     */
    clientId: string;
    /**
     * 
     * @type {Array<AssetDependantResponse>}
     * @memberof AssetDependantsResponse
     */
    dependants: Array<AssetDependantResponse>;
}

/**
 * 
 * @export
 * @interface AssetIncomeMonthRequest
 */
export interface AssetIncomeMonthRequest {
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    year: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    month: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    paidAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    garnishedAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    expenseAllowance: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    familyAllowance: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthRequest
     */
    employerSettledExpenses: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeMonthRequest
     */
    specialPaymentPaid: boolean | null;
}

/**
 * 
 * @export
 * @interface AssetIncomeMonthResponse
 */
export interface AssetIncomeMonthResponse {
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    year: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    month: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    paidAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    garnishedAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    expenseAllowance: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    familyAllowance: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    employerSettledExpenses: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeMonthResponse
     */
    specialPaymentPaid: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    monthlyIncome: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeMonthResponse
     */
    countsTowardsAverage: boolean;
}

/**
 * 
 * @export
 * @interface AssetIncomeRequest
 */
export interface AssetIncomeRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeRequest
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeRequest
     */
    payerNameAndAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeRequest
     */
    incomeType: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    hasSpecialPayments: boolean | null;
    /**
     * 
     * @type {SpecialPaymentCount}
     * @memberof AssetIncomeRequest
     */
    specialPaymentCount: SpecialPaymentCount | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeRequest
     */
    dailyRate: number | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeRequest
     */
    note: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    isPartiallyGarnished: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    hasEmployerFamilyAllowance: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    hasEmployerSettledExpenses: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    hasBenefitInKind: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeRequest
     */
    benefitInKindAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    receivesTips: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeRequest
     */
    monthlyTipAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    hasExpenseAllowances: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    isAverageRepresentative: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeRequest
     */
    nonRepresentativeReason: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeRequest
     */
    actualAverageIncome: number | null;
    /**
     * 
     * @type {Array<AssetIncomeMonthRequest>}
     * @memberof AssetIncomeRequest
     */
    months: Array<AssetIncomeMonthRequest>;
}

/**
 * 
 * @export
 * @interface AssetIncomeResponse
 */
export interface AssetIncomeResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeResponse
     */
    payerNameAndAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeResponse
     */
    incomeType: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    hasSpecialPayments: boolean | null;
    /**
     * 
     * @type {SpecialPaymentCount}
     * @memberof AssetIncomeResponse
     */
    specialPaymentCount: SpecialPaymentCount | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeResponse
     */
    dailyRate: number | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeResponse
     */
    note: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    isPartiallyGarnished: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    hasEmployerFamilyAllowance: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    hasEmployerSettledExpenses: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    hasBenefitInKind: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeResponse
     */
    benefitInKindAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    receivesTips: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeResponse
     */
    monthlyTipAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    hasExpenseAllowances: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    isAverageRepresentative: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeResponse
     */
    nonRepresentativeReason: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeResponse
     */
    actualAverageIncome: number | null;
    /**
     * 
     * @type {Array<AssetIncomeMonthResponse>}
     * @memberof AssetIncomeResponse
     */
    months: Array<AssetIncomeMonthResponse>;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeResponse
     */
    averageIncome: number | null;
}

/**
 * 
 * @export
 * @interface AssetIncomeTabResponse
 */
export interface AssetIncomeTabResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeTabResponse
     */
    clientId: string;
    /**
     * 
     * @type {AssetSelfEmploymentResponse}
     * @memberof AssetIncomeTabResponse
     */
    selfEmployment: AssetSelfEmploymentResponse;
    /**
     * 
     * @type {Array<AssetIncomeResponse>}
     * @memberof AssetIncomeTabResponse
     */
    incomes: Array<AssetIncomeResponse>;
    /**
     * 
     * @type {SeizableIncomeAssessmentResponse}
     * @memberof AssetIncomeTabResponse
     */
    assessment: SeizableIncomeAssessmentResponse;
}

/**
 * 
 * @export
 * @interface AssetInventoryCompletenessResponse
 */
export interface AssetInventoryCompletenessResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryCompletenessResponse
     */
    clientId: string;
    /**
     * 
     * @type {Array<AssetInventorySectionCompletenessResponse>}
     * @memberof AssetInventoryCompletenessResponse
     */
    sections: Array<AssetInventorySectionCompletenessResponse>;
}

/**
 * 
 * @export
 */
export const AssetInventoryCompletenessSection = {
    Relatives: 'Relatives',
    Income: 'Income',
    Expenses: 'Expenses',
    OwnClaims: 'OwnClaims',
    Assets: 'Assets',
    PropertyRights: 'PropertyRights',
    Donations: 'Donations'
} as const;
export type AssetInventoryCompletenessSection = typeof AssetInventoryCompletenessSection[keyof typeof AssetInventoryCompletenessSection];

/**
 * 
 * @export
 * @interface AssetInventoryDocumentResponse
 */
export interface AssetInventoryDocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDocumentResponse
     */
    documentId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDocumentResponse
     */
    sourceFileId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDocumentResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDocumentResponse
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDocumentResponse
     */
    contentType: string;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryDocumentResponse
     */
    fileSizeBytes: number;
    /**
     * 
     * @type {boolean}
     * @memberof AssetInventoryDocumentResponse
     */
    isPreviewAvailable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetInventoryDocumentResponse
     */
    isRead: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AssetInventoryDocumentResponse
     */
    createdAtUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDocumentResponse
     */
    createdByUserCode: string;
}

/**
 * 
 * @export
 * @interface AssetInventoryMissingFieldResponse
 */
export interface AssetInventoryMissingFieldResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryMissingFieldResponse
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryMissingFieldResponse
     */
    itemId: string | null;
}

/**
 * 
 * @export
 * @interface AssetInventorySectionCompletenessResponse
 */
export interface AssetInventorySectionCompletenessResponse {
    /**
     * 
     * @type {AssetInventoryCompletenessSection}
     * @memberof AssetInventorySectionCompletenessResponse
     */
    section: AssetInventoryCompletenessSection;
    /**
     * 
     * @type {boolean}
     * @memberof AssetInventorySectionCompletenessResponse
     */
    hasData: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetInventorySectionCompletenessResponse
     */
    hasWarning: boolean;
    /**
     * 
     * @type {Array<AssetInventoryMissingFieldResponse>}
     * @memberof AssetInventorySectionCompletenessResponse
     */
    missingFields: Array<AssetInventoryMissingFieldResponse>;
}

/**
 * 
 * @export
 */
export const AssetExpensePosition = {
    Rent: 'Rent',
    HomeOwnership: 'HomeOwnership',
    Energy: 'Energy',
    Heating: 'Heating',
    Phone: 'Phone',
    Broadcasting: 'Broadcasting',
    Childcare: 'Childcare',
    PublicTransport: 'PublicTransport',
    HouseholdInsurance: 'HouseholdInsurance',
    LifeInsurance: 'LifeInsurance',
    OtherInsurance: 'OtherInsurance',
    Vehicles: 'Vehicles',
    VehicleInsuranceAndTax: 'VehicleInsuranceAndTax',
    Fuel: 'Fuel',
    Parking: 'Parking',
    LivingCosts: 'LivingCosts',
    Other: 'Other'
} as const;
export type AssetExpensePosition = typeof AssetExpensePosition[keyof typeof AssetExpensePosition];

/**
 * 
 * @export
 * @interface AssetExpenseRequest
 */
export interface AssetExpenseRequest {
    /**
     * 
     * @type {AssetExpensePosition}
     * @memberof AssetExpenseRequest
     */
    position: AssetExpensePosition;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseRequest
     */
    amount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseRequest
     */
    debtorShare: number | null;
}

/**
 * 
 * @export
 * @interface AssetExpenseResponse
 */
export interface AssetExpenseResponse {
    /**
     * 
     * @type {AssetExpensePosition}
     * @memberof AssetExpenseResponse
     */
    position: AssetExpensePosition;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseResponse
     */
    amount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseResponse
     */
    debtorShare: number;
}

/**
 * 
 * @export
 * @interface AssetExpenseSummaryResponse
 */
export interface AssetExpenseSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseSummaryResponse
     */
    totalExpenses: number;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseSummaryResponse
     */
    totalIncome: number;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseSummaryResponse
     */
    seizableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseSummaryResponse
     */
    remainingIncome: number;
    /**
     * 
     * @type {boolean}
     * @memberof AssetExpenseSummaryResponse
     */
    isIncomeAvailable: boolean;
}

/**
 * 
 * @export
 * @interface AssetExpensesTabResponse
 */
export interface AssetExpensesTabResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetExpensesTabResponse
     */
    clientId: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssetExpensesTabResponse
     */
    hasIllnessExtraCosts: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetExpensesTabResponse
     */
    illnessExtraCostAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetExpensesTabResponse
     */
    paysCostsAlone: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetExpensesTabResponse
     */
    costSharingExplanation: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetExpensesTabResponse
     */
    expenseRemarks: string | null;
    /**
     * 
     * @type {Array<AssetExpenseResponse>}
     * @memberof AssetExpensesTabResponse
     */
    expenses: Array<AssetExpenseResponse>;
    /**
     * 
     * @type {AssetMaintenanceExpenseResponse}
     * @memberof AssetExpensesTabResponse
     */
    maintenance: AssetMaintenanceExpenseResponse;
    /**
     * 
     * @type {AssetExpenseSummaryResponse}
     * @memberof AssetExpensesTabResponse
     */
    summary: AssetExpenseSummaryResponse;
}

/**
 * 
 * @export
 * @interface AssetMaintenanceExpenseResponse
 */
export interface AssetMaintenanceExpenseResponse {
    /**
     * 
     * @type {number}
     * @memberof AssetMaintenanceExpenseResponse
     */
    personCount: number;
    /**
     * 
     * @type {number}
     * @memberof AssetMaintenanceExpenseResponse
     */
    amount: number;
}

/**
 * 
 * @export
 * @interface AssetOwnClaimRequest
 */
export interface AssetOwnClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    debtorName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    debtorAddress: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimRequest
     */
    isRelated: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    relationship: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    legalReason: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetOwnClaimRequest
     */
    amount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetOwnClaimRequest
     */
    dueDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimRequest
     */
    isSecured: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    securities: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimRequest
     */
    isDisputed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimRequest
     */
    hasPendingCourtProceedings: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    disputeDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimRequest
     */
    isCollectible: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    collectionSteps: string | null;
}

/**
 * 
 * @export
 * @interface AssetOwnClaimResponse
 */
export interface AssetOwnClaimResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimResponse
     */
    debtorName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimResponse
     */
    debtorAddress: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimResponse
     */
    isRelated: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimResponse
     */
    relationship: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimResponse
     */
    legalReason: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetOwnClaimResponse
     */
    amount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetOwnClaimResponse
     */
    dueDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimResponse
     */
    isSecured: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimResponse
     */
    securities: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimResponse
     */
    isDisputed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimResponse
     */
    hasPendingCourtProceedings: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimResponse
     */
    disputeDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimResponse
     */
    isCollectible: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimResponse
     */
    collectionSteps: string | null;
}

/**
 * 
 * @export
 * @interface AssetOwnClaimsTabResponse
 */
export interface AssetOwnClaimsTabResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimsTabResponse
     */
    clientId: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimsTabResponse
     */
    hasOwnClaims: boolean | null;
    /**
     * 
     * @type {Array<AssetOwnClaimResponse>}
     * @memberof AssetOwnClaimsTabResponse
     */
    ownClaims: Array<AssetOwnClaimResponse>;
}

/**
 * 
 * @export
 * @interface AssetPersonalDataClientPart
 */
export interface AssetPersonalDataClientPart {
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    salutation: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    formerLastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    insuranceNumber: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetPersonalDataClientPart
     */
    birthday: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    placeOfBirth: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    houseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataClientPart
     */
    employmentStatus: string | null;
}

/**
 * 
 * @export
 * @interface AssetPersonalDataInventoryPart
 */
export interface AssetPersonalDataInventoryPart {
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataInventoryPart
     */
    causesDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetPersonalDataInventoryPart
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPersonalDataInventoryPart
     */
    hasOwnAccount: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetPersonalDataInventoryPart
     */
    hasFurtherAccount: boolean | null;
    /**
     * 
     * @type {Array<AssetAccountResponse>}
     * @memberof AssetPersonalDataInventoryPart
     */
    accounts: Array<AssetAccountResponse>;
    /**
     * 
     * @type {Date}
     * @memberof AssetPersonalDataInventoryPart
     */
    lastChangedAtUtc: Date | null;
}

/**
 * 
 * @export
 * @interface AssetPersonalDataResponse
 */
export interface AssetPersonalDataResponse {
    /**
     * 
     * @type {AssetPersonalDataClientPart}
     * @memberof AssetPersonalDataResponse
     */
    personalData: AssetPersonalDataClientPart;
    /**
     * 
     * @type {AssetPersonalDataInventoryPart}
     * @memberof AssetPersonalDataResponse
     */
    assetInventory: AssetPersonalDataInventoryPart;
}

/**
 * 
 * @export
 * @interface AssetSelfEmploymentResponse
 */
export interface AssetSelfEmploymentResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AssetSelfEmploymentResponse
     */
    hasSelfEmploymentIncome: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSelfEmploymentResponse
     */
    description: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetSelfEmploymentResponse
     */
    monthlyIncome: number | null;
}

/**
 * 
 * @export
 */
export const RelationshipType = {
    Acquaintance: 'Acquaintance',
    Parent: 'Parent',
    ExSpouse: 'ExSpouse',
    ExPartner: 'ExPartner',
    Spouse: 'Spouse',
    Child: 'Child',
    Partner: 'Partner',
    Other: 'Other',
    Unknown: 'Unknown',
    Relative: 'Relative'
} as const;
export type RelationshipType = typeof RelationshipType[keyof typeof RelationshipType];

/**
 * 
 * @export
 * @interface SaveAssetDependantsRequest
 */
export interface SaveAssetDependantsRequest {
    /**
     * 
     * @type {Array<AssetDependantRequest>}
     * @memberof SaveAssetDependantsRequest
     */
    dependants: Array<AssetDependantRequest>;
}

/**
 * 
 * @export
 * @interface SaveAssetIncomeRequest
 */
export interface SaveAssetIncomeRequest {
    /**
     * 
     * @type {SaveAssetSelfEmploymentRequest}
     * @memberof SaveAssetIncomeRequest
     */
    selfEmployment: SaveAssetSelfEmploymentRequest;
    /**
     * 
     * @type {Array<AssetIncomeRequest>}
     * @memberof SaveAssetIncomeRequest
     */
    incomes: Array<AssetIncomeRequest>;
}

/**
 * 
 * @export
 * @interface SaveAssetOwnClaimsRequest
 */
export interface SaveAssetOwnClaimsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveAssetOwnClaimsRequest
     */
    hasOwnClaims: boolean | null;
    /**
     * 
     * @type {Array<AssetOwnClaimRequest>}
     * @memberof SaveAssetOwnClaimsRequest
     */
    ownClaims: Array<AssetOwnClaimRequest>;
}

/**
 * 
 * @export
 * @interface SaveAssetExpensesRequest
 */
export interface SaveAssetExpensesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveAssetExpensesRequest
     */
    hasIllnessExtraCosts: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof SaveAssetExpensesRequest
     */
    illnessExtraCostAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveAssetExpensesRequest
     */
    paysCostsAlone: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetExpensesRequest
     */
    costSharingExplanation: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetExpensesRequest
     */
    expenseRemarks: string | null;
    /**
     * 
     * @type {Array<AssetExpenseRequest>}
     * @memberof SaveAssetExpensesRequest
     */
    expenses: Array<AssetExpenseRequest>;
}

/**
 * 
 * @export
 * @interface SaveAssetPersonalDataClientPart
 */
export interface SaveAssetPersonalDataClientPart {
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    salutation: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    formerLastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    insuranceNumber: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SaveAssetPersonalDataClientPart
     */
    birthday: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    placeOfBirth: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    houseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    employmentStatus: string | null;
}

/**
 * 
 * @export
 * @interface SaveAssetPersonalDataInventoryPart
 */
export interface SaveAssetPersonalDataInventoryPart {
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataInventoryPart
     */
    causesDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataInventoryPart
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveAssetPersonalDataInventoryPart
     */
    hasOwnAccount: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveAssetPersonalDataInventoryPart
     */
    hasFurtherAccount: boolean | null;
    /**
     * 
     * @type {Array<AssetAccountRequest>}
     * @memberof SaveAssetPersonalDataInventoryPart
     */
    accounts: Array<AssetAccountRequest>;
}

/**
 * 
 * @export
 * @interface SaveAssetPersonalDataRequest
 */
export interface SaveAssetPersonalDataRequest {
    /**
     * 
     * @type {SaveAssetPersonalDataClientPart}
     * @memberof SaveAssetPersonalDataRequest
     */
    personalData: SaveAssetPersonalDataClientPart;
    /**
     * 
     * @type {SaveAssetPersonalDataInventoryPart}
     * @memberof SaveAssetPersonalDataRequest
     */
    assetInventory: SaveAssetPersonalDataInventoryPart;
}

/**
 * 
 * @export
 * @interface SaveAssetsRequest
 */
export interface SaveAssetsRequest {
    /**
     * 
     * @type {AssetAnswersDto}
     * @memberof SaveAssetsRequest
     */
    answers: AssetAnswersDto;
    /**
     * 
     * @type {Array<AssetFinancialHoldingRequest>}
     * @memberof SaveAssetsRequest
     */
    financialHoldings: Array<AssetFinancialHoldingRequest>;
}

/**
 * 
 * @export
 * @interface SaveDonationsRequest
 */
export interface SaveDonationsRequest {
    /**
     * 
     * @type {DonationAnswersDto}
     * @memberof SaveDonationsRequest
     */
    answers: DonationAnswersDto;
}

/**
 * 
 * @export
 * @interface SavePropertyRightsRequest
 */
export interface SavePropertyRightsRequest {
    /**
     * 
     * @type {PropertyRightAnswersDto}
     * @memberof SavePropertyRightsRequest
     */
    answers: PropertyRightAnswersDto;
    /**
     * 
     * @type {Array<AssetPropertyRightRequest>}
     * @memberof SavePropertyRightsRequest
     */
    propertyRights: Array<AssetPropertyRightRequest>;
}

/**
 * 
 * @export
 * @interface SaveAssetSelfEmploymentRequest
 */
export interface SaveAssetSelfEmploymentRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveAssetSelfEmploymentRequest
     */
    hasSelfEmploymentIncome: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetSelfEmploymentRequest
     */
    description: string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveAssetSelfEmploymentRequest
     */
    monthlyIncome: number | null;
}

/**
 * 
 * @export
 * @interface SeizableIncomeAssessmentResponse
 */
export interface SeizableIncomeAssessmentResponse {
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    income12: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    income14: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    nonSeizableIncome: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    totalIncome: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    maintenanceObligationCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof SeizableIncomeAssessmentResponse
     */
    isCalculated: boolean;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    seizableAmount12: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    seizableAmount14: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    remainingIncome: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    subsistenceAmount12: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    subsistenceAmount14: number | null;
    /**
     * 
     * @type {Array<SeizableIncomeExplanationLineResponse>}
     * @memberof SeizableIncomeAssessmentResponse
     */
    explanation: Array<SeizableIncomeExplanationLineResponse>;
}

/**
 * 
 * @export
 */
export const SeizableIncomeExplanationKind = {
    NoIncome: 'NoIncome',
    SingleStream: 'SingleStream',
    StreamSeizable: 'StreamSeizable',
    StreamSeizableWithPercentage: 'StreamSeizableWithPercentage',
    StreamFullyProtected: 'StreamFullyProtected',
    OtherStreamAlsoProtected: 'OtherStreamAlsoProtected',
    OtherStreamSeizableAfterDifference: 'OtherStreamSeizableAfterDifference',
    AliquotSplit: 'AliquotSplit',
    AliquotStreamProtected: 'AliquotStreamProtected',
    AliquotFullyProtected: 'AliquotFullyProtected'
} as const;
export type SeizableIncomeExplanationKind = typeof SeizableIncomeExplanationKind[keyof typeof SeizableIncomeExplanationKind];

/**
 * 
 * @export
 * @interface SeizableIncomeExplanationLineResponse
 */
export interface SeizableIncomeExplanationLineResponse {
    /**
     * 
     * @type {SeizableIncomeExplanationKind}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    kind: SeizableIncomeExplanationKind;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    paymentsPerYear: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    income: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    seizableAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    maintenanceObligationCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    otherIncome: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    share: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    subsistenceAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    baseAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    percentage: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    difference: number | null;
}

/**
 * 
 * @export
 */
export const SpecialPaymentCount = {
    One: 'One',
    Two: 'Two',
    ThreeOrMore: 'ThreeOrMore'
} as const;
export type SpecialPaymentCount = typeof SpecialPaymentCount[keyof typeof SpecialPaymentCount];

/**
 * 
 * @export
 * @interface ClientNoteResponse
 */
export interface ClientNoteResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientNoteResponse
     */
    note: string | null;
}

/**
 * 
 * @export
 * @interface UpdateClientNoteRequest
 */
export interface UpdateClientNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientNoteRequest
     */
    note?: string | null;
}

/**
 * 
 * @export
 * @interface DocumentResponse
 */
export interface DocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof DocumentResponse
     */
    documentId: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentResponse
     */
    sourceFileId: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentResponse
     */
    clientId: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentResponse
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentResponse
     */
    contentType: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentResponse
     */
    fileSizeBytes: number;
    /**
     * 
     * @type {Date}
     * @memberof DocumentResponse
     */
    assignedAtUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentResponse
     */
    assignedByUserCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentResponse
     */
    isPreviewAvailable: boolean;
}

/**
 * 
 * @export
 * @interface BalanceEntryRequest
 */
export interface BalanceEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof BalanceEntryRequest
     */
    id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof BalanceEntryRequest
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof BalanceEntryRequest
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof BalanceEntryRequest
     */
    entryType?: string | null;
}

/**
 * 
 * @export
 * @interface BalanceEntryResponse
 */
export interface BalanceEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof BalanceEntryResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BalanceEntryResponse
     */
    claimId: string;
    /**
     * 
     * @type {Date}
     * @memberof BalanceEntryResponse
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof BalanceEntryResponse
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof BalanceEntryResponse
     */
    entryType: string | null;
}

/**
 * 
 * @export
 * @interface ClaimCollateralHoldingRequest
 */
export interface ClaimCollateralHoldingRequest {
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    institutionName: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    accountNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    country: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimCollateralHoldingRequest
     */
    isValueKnown: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimCollateralHoldingRequest
     */
    value: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimCollateralHoldingRequest
     */
    valueDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralHoldingRequest
     */
    remarks: string | null;
}

/**
 * 
 * @export
 * @interface ClaimCollateralRequest
 */
export interface ClaimCollateralRequest {
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralRequest
     */
    id: string | null;
    /**
     * 
     * @type {ClaimCollateralType}
     * @memberof ClaimCollateralRequest
     */
    type: ClaimCollateralType;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralRequest
     */
    holdingId: string | null;
    /**
     * 
     * @type {ClaimCollateralHoldingRequest}
     * @memberof ClaimCollateralRequest
     */
    newHolding: ClaimCollateralHoldingRequest | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralRequest
     */
    details: string | null;
}

/**
 * 
 * @export
 * @interface ClaimCollateralResponse
 */
export interface ClaimCollateralResponse {
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralResponse
     */
    id: string;
    /**
     * 
     * @type {ClaimCollateralType}
     * @memberof ClaimCollateralResponse
     */
    type: ClaimCollateralType;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralResponse
     */
    holdingId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralResponse
     */
    details: string | null;
}

/**
 * 
 * @export
 */
export const ClaimCollateralType = {
    BuildingSavingsContract: 'BuildingSavingsContract',
    LifeInsurance: 'LifeInsurance',
    PensionInsurance: 'PensionInsurance',
    SavingsAccount: 'SavingsAccount',
    Securities: 'Securities',
    RealEstate: 'RealEstate',
    WagePledge: 'WagePledge',
    Other: 'Other'
} as const;
export type ClaimCollateralType = typeof ClaimCollateralType[keyof typeof ClaimCollateralType];

/**
 * 
 * @export
 * @interface ClaimResponse
 */
export interface ClaimResponse {
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    creditorId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    creditorName: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    creditorAddress: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimResponse
     */
    isCreditorInactive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimResponse
     */
    isCreditorClientSpecific: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    representativeId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    representativeName: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    representativeAddress: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimResponse
     */
    isRepresentativeInactive: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimResponse
     */
    isRepresentativeClientSpecific: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    caseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    legalBasis: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    disputedStatus: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    collateralStatus: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    expectedLossPercent: number | null;
    /**
     * 
     * @type {Array<ClaimCollateralResponse>}
     * @memberof ClaimResponse
     */
    collaterals: Array<ClaimCollateralResponse>;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    claimEntirelyDisputed: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    recognizedAmount: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    srvRegistrationStatus: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    srvOrderNumber: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    notes: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimResponse
     */
    isCompleted: boolean;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    currentSaldo: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    disputedAmount: number;
    /**
     * 
     * @type {Array<BalanceEntryResponse>}
     * @memberof ClaimResponse
     */
    balanceEntries: Array<BalanceEntryResponse>;
    /**
     * 
     * @type {Date}
     * @memberof ClaimResponse
     */
    balanceListVersionUtc: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimResponse
     */
    lastChangedAtUtc?: Date | null;
}

/**
 * 
 * @export
 * @interface CreateClaimRequest
 */
export interface CreateClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    creditorId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    representativeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    legalBasis: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    disputedStatus: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    collateralStatus: string;
    /**
     * 
     * @type {number}
     * @memberof CreateClaimRequest
     */
    expectedLossPercent?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    claimEntirelyDisputed?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateClaimRequest
     */
    recognizedAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    srvRegistrationStatus?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateClaimRequest
     */
    srvOrderNumber?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    notes?: string | null;
    /**
     * 
     * @type {Array<ClaimCollateralRequest>}
     * @memberof CreateClaimRequest
     */
    collaterals?: Array<ClaimCollateralRequest>;
    /**
     * 
     * @type {Array<BalanceEntryRequest>}
     * @memberof CreateClaimRequest
     */
    balanceEntries?: Array<BalanceEntryRequest>;
}

/**
 * 
 * @export
 * @interface UpdateClaimRequest
 */
export interface UpdateClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    representativeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    legalBasis: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    disputedStatus: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    collateralStatus: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateClaimRequest
     */
    expectedLossPercent?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    claimEntirelyDisputed?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateClaimRequest
     */
    recognizedAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    srvRegistrationStatus?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateClaimRequest
     */
    srvOrderNumber?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    notes?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClaimRequest
     */
    isCompleted?: boolean;
    /**
     * 
     * @type {Array<ClaimCollateralRequest>}
     * @memberof UpdateClaimRequest
     */
    collaterals?: Array<ClaimCollateralRequest>;
    /**
     * 
     * @type {Array<BalanceEntryRequest>}
     * @memberof UpdateClaimRequest
     */
    balanceEntries?: Array<BalanceEntryRequest>;
    /**
     * 
     * @type {Date}
     * @memberof UpdateClaimRequest
     */
    expectedBalanceListVersionUtc?: Date | null;
}

/**
 * 
 * @export
 * @interface CreateClientSpecificProceedingParticipantRequest
 */
export interface CreateClientSpecificProceedingParticipantRequest {
    /**
     * 
     * @type {ProceedingParticipantType}
     * @memberof CreateClientSpecificProceedingParticipantRequest
     */
    type: ProceedingParticipantType | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientSpecificProceedingParticipantRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClientSpecificProceedingParticipantRequest
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientSpecificProceedingParticipantRequest
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientSpecificProceedingParticipantRequest
     */
    country: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientSpecificProceedingParticipantRequest
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientSpecificProceedingParticipantRequest
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientSpecificProceedingParticipantRequest
     */
    note: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClientSpecificProceedingParticipantRequest
     */
    createAsGlobal?: boolean;
}

/**
 * 
 * @export
 * @interface ProceedingParticipantResponse
 */
export interface ProceedingParticipantResponse {
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    proceedingParticipantId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProceedingParticipantResponse
     */
    isGlobal: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    owningClientId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProceedingParticipantResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    deactivationReason: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProceedingParticipantResponse
     */
    deactivatedAtUtc: Date | null;
    /**
     * 
     * @type {ProceedingParticipantType}
     * @memberof ProceedingParticipantResponse
     */
    type: ProceedingParticipantType;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    country: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    note: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    mergeHistory: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProceedingParticipantResponse
     */
    lastChangedAtUtc?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    lastChangedByUserCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    deactivatedByUserCode?: string | null;
}

/**
 * 
 * @export
 * @interface ProceedingParticipantSearchResult
 */
export interface ProceedingParticipantSearchResult {
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    proceedingParticipantId: string;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    name: string;
    /**
     * 
     * @type {ProceedingParticipantType}
     * @memberof ProceedingParticipantSearchResult
     */
    type: ProceedingParticipantType;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantSearchResult
     */
    country: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProceedingParticipantSearchResult
     */
    isClientSpecific: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProceedingParticipantSearchResult
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ProceedingParticipantSearchResult
     */
    deactivatedAtUtc: Date | null;
}

/**
 * 
 * @export
 */
export const ProceedingParticipantType = {
    Creditor: 'Creditor',
    LawFirm: 'LawFirm',
    DebtCollectionAgency: 'DebtCollectionAgency',
    Trustee: 'Trustee',
    InsolvencyAdministrator: 'InsolvencyAdministrator',
    Organisation: 'Organisation',
    Bank: 'Bank',
    Insurance: 'Insurance'
} as const;
export type ProceedingParticipantType = typeof ProceedingParticipantType[keyof typeof ProceedingParticipantType];

/**
 * 
 * @export
 * @interface SearchResultsOfProceedingParticipantSearchResult
 */
export interface SearchResultsOfProceedingParticipantSearchResult {
    /**
     * 
     * @type {Array<ProceedingParticipantSearchResult>}
     * @memberof SearchResultsOfProceedingParticipantSearchResult
     */
    data: Array<ProceedingParticipantSearchResult>;
    /**
     * 
     * @type {boolean}
     * @memberof SearchResultsOfProceedingParticipantSearchResult
     */
    hasMoreItems: boolean;
}

/**
 * 
 * @export
 * @interface UpdateProceedingParticipantRequest
 */
export interface UpdateProceedingParticipantRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    country: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    note: string | null;
}

/**
 * 
 * @export
 */
export const DropdownCategory = {
    Salutation: 'Salutation',
    Title: 'Title',
    Citizenship: 'Citizenship',
    MediaInquiry: 'MediaInquiry',
    ContactSource: 'ContactSource',
    Country: 'Country',
    City: 'City',
    EmploymentStatus: 'EmploymentStatus',
    AssignmentPriority: 'AssignmentPriority',
    CaseNoteLocation: 'CaseNoteLocation',
    CaseNoteResult: 'CaseNoteResult',
    Qualification: 'Qualification',
    MaritalStatus: 'MaritalStatus',
    LivingSituation: 'LivingSituation',
    ClientGoalAndResult: 'ClientGoalAndResult',
    ClientMeasures: 'ClientMeasures',
    ClientCauses: 'ClientCauses',
    AppointmentLocation: 'AppointmentLocation',
    ClaimLegalBasis: 'ClaimLegalBasis',
    Recommendation: 'Recommendation',
    RegisteredBy: 'RegisteredBy',
    Team: 'Team',
    WorkArea: 'WorkArea',
    SrvCounselingType: 'SrvCounselingType',
    SrvCourseEntryResult: 'SrvCourseEntryResult',
    IdentityDocumentType: 'IdentityDocumentType'
} as const;
export type DropdownCategory = typeof DropdownCategory[keyof typeof DropdownCategory];

/**
 * 
 * @export
 * @interface DropdownOptionResponse
 */
export interface DropdownOptionResponse {
    /**
     * 
     * @type {string}
     * @memberof DropdownOptionResponse
     */
    id: string;
    /**
     * 
     * @type {DropdownCategory}
     * @memberof DropdownOptionResponse
     */
    category: DropdownCategory;
    /**
     * 
     * @type {string}
     * @memberof DropdownOptionResponse
     */
    value: string;
}

/**
 * 
 * @export
 */
export const SystemDropdownCategory = {
    AppointmentPurpose: 'AppointmentPurpose',
    AttendancePurpose: 'AttendancePurpose',
    CaseNoteType: 'CaseNoteType',
    ClientStatus: 'ClientStatus',
    ClaimBalanceEntryType: 'ClaimBalanceEntryType',
    SrvCourseEntryType: 'SrvCourseEntryType',
    IncomeType: 'IncomeType'
} as const;
export type SystemDropdownCategory = typeof SystemDropdownCategory[keyof typeof SystemDropdownCategory];

/**
 * 
 * @export
 * @interface SystemDropdownOptionResponse
 */
export interface SystemDropdownOptionResponse {
    /**
     * 
     * @type {string}
     * @memberof SystemDropdownOptionResponse
     */
    id: string;
    /**
     * 
     * @type {SystemDropdownCategory}
     * @memberof SystemDropdownOptionResponse
     */
    category: SystemDropdownCategory;
    /**
     * 
     * @type {string}
     * @memberof SystemDropdownOptionResponse
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof SystemDropdownOptionResponse
     */
    value: string;
    /**
     * 
     * @type {boolean}
     * @memberof SystemDropdownOptionResponse
     */
    isHidden: boolean;
    /**
     * 
     * @type {Array<SystemDropdownParameterResponse>}
     * @memberof SystemDropdownOptionResponse
     */
    parameters: Array<SystemDropdownParameterResponse>;
}

/**
 * 
 * @export
 */
export const SystemDropdownParameter = {
    Overbookable: 'Overbookable',
    AttendanceType: 'AttendanceType',
    Deletable: 'Deletable',
    Editable: 'Editable',
    SrvRegistered: 'SrvRegistered',
    Projected: 'Projected',
    IncomeTreatment: 'IncomeTreatment',
    AvailableInExchange: 'AvailableInExchange',
    Conversation: 'Conversation'
} as const;
export type SystemDropdownParameter = typeof SystemDropdownParameter[keyof typeof SystemDropdownParameter];

/**
 * 
 * @export
 * @interface SystemDropdownParameterResponse
 */
export interface SystemDropdownParameterResponse {
    /**
     * 
     * @type {SystemDropdownParameter}
     * @memberof SystemDropdownParameterResponse
     */
    parameter: SystemDropdownParameter;
    /**
     * 
     * @type {string}
     * @memberof SystemDropdownParameterResponse
     */
    value: string;
}
